export default function Maps_Controls() {
  return (
    <div>
      <h1>Maps_Controls Component</h1>
    </div>
  );
}
